import { useEffect, useState } from "react";

import { SocraticState } from "../socratic-slice";

export const MIN_RECORDING_DURATION_MS = 5000;

export interface DialogueControls {
  canStartEarly: boolean;
  canShowStopEarly: boolean;
  canStopEarly: boolean;
}

/**
 * A helper to determine the current phase of the Socratic dialogue based on the
 * recording state.
 */
export function useDialogueControls(
  dialogueTimeline: SocraticState["dialogueTimeline"]
): DialogueControls {
  const {
    preparationEndDate,
    responseEndDate,
    isRecording,
    recordingComplete,
  } = dialogueTimeline;

  const [minRecordingTimeElapsed, setMinRecordingTimeElapsed] = useState(false);

  useEffect(() => {
    if (!isRecording) {
      setMinRecordingTimeElapsed(false);
      return;
    }
    const timer = setTimeout(() => {
      setMinRecordingTimeElapsed(true);
    }, MIN_RECORDING_DURATION_MS);
    return () => clearTimeout(timer);
  }, [isRecording]);

  // Determine current phase
  const isPreparationPhase =
    preparationEndDate.passed === false &&
    !isRecording &&
    responseEndDate.passed === false &&
    !recordingComplete;

  const canStartEarly = isPreparationPhase && !recordingComplete;
  const canShowStopEarly = isRecording && responseEndDate.passed === false;
  const canStopEarly = canShowStopEarly && minRecordingTimeElapsed;

  return {
    canStartEarly,
    canShowStopEarly,
    canStopEarly,
  };
}
